import { URL_SELLER_BRAND_CONTACT_PAGE_SPACE } from '@tools/routes/routes';

export const getXhrPageSpaceContactUrl = ({ pageSpaceId }) => URL_SELLER_BRAND_CONTACT_PAGE_SPACE.replace('{id}', pageSpaceId);
